(() => {
  const mobile = window.matchMedia('(max-width: 760px)');
  const root = document.querySelector('.m27-page, [data-model-product]');
  const hero = root?.querySelector('.m27-gallery__stage, .model-product__hero');
  const stock = root?.querySelector('[data-m27-stock], [data-model-availability]');
  if (!hero || !stock) return;

  let frame;
  const fitFirstScreen = () => {
    if (!mobile.matches) {
      const viewport = window.visualViewport?.height || window.innerHeight;
      const heroRect = hero.getBoundingClientRect();
      // Use document coordinates so scrolling never changes the image size.
      const heroTop = heroRect.top + window.scrollY;
      const available = viewport - heroTop - 40;
      const height = Math.max(120, Math.min(620, heroRect.width, Math.floor(available)));
      root.style.setProperty('--hz-pdp-image-height', `${height}px`);
      return;
    }
    // Leave focused inputs and the software keyboard undisturbed.
    if (document.activeElement?.matches('input, textarea, select')) return;
    const viewport = window.visualViewport?.height || window.innerHeight;
    const sticky = root.querySelector('.m27-mobile-buybar, .model-product__sticky');
    const bottomSpace = sticky?.getBoundingClientRect().height || 64;
    const heroHeight = hero.getBoundingClientRect().height;
    const stockBottom = stock.getBoundingClientRect().bottom + window.scrollY;
    const otherContent = stockBottom - heroHeight;
    const height = Math.max(160, Math.min(420, Math.floor(viewport - bottomSpace - otherContent - 16)));
    root.style.setProperty('--hz-pdp-image-height', `${height}px`);
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitFirstScreen);
  };
  const observer = new ResizeObserver(schedule);
  const heading = root.querySelector('.m27-product-heading, .model-product__heading');
  if (heading) observer.observe(heading);
  const header = document.querySelector('.m27-store-header');
  if (header) observer.observe(header);
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  mobile.addEventListener('change', schedule);
  document.fonts.ready.then(schedule);
  schedule();
})();
